import Index from '@tunnel-components/@pages/lapi-tmd/incidents/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/lapi-tmd/incidents/index.ts